'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkSkuCardMinimal.module.css';

export function DevlinkSkuCardMinimal({
  as: _Component = _Builtin.Link,
  skuName = 'SKUName',
  showSkuIcon = true,
  skuIcon = '',
  altText = '__wf_reserved_inherit',
  showSkuIconSlot = true,
  skuIconSlot,
  action = {},
}) {
  return (
    <_Component
      className={_utils.cx(_styles, 'ht-min-sku-card')}
      button={false}
      dyn={{
        bind: {},
      }}
      block="inline"
      options={{
        href: '#',
      }}
      {...action}
    >
      <_Builtin.Block className={_utils.cx(_styles, 'ht-min-sku-card-icon-group')} tag="div">
        <_Builtin.Image
          className={_utils.cx(_styles, 'ht-icon-blob-backdrop')}
          dyn={{
            bind: {},
          }}
          width="auto"
          height="auto"
          loading="lazy"
          alt=""
          src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/61d72eabd021d3396c040575_Bean.png"
        />
        {showSkuIcon ? (
          <_Builtin.Image className={_utils.cx(_styles, 'ht-min-sku-card-icon')} width="56" height="56" loading="lazy" src={skuIcon} />
        ) : null}
        {showSkuIconSlot ? (
          <_Builtin.Block className={_utils.cx(_styles, 'ht-min-sku-card-icon')} tag="div">
            {skuIconSlot}
          </_Builtin.Block>
        ) : null}
      </_Builtin.Block>
      <_Builtin.Block className={_utils.cx(_styles, 'small-1')} tag="div" />
      <_Builtin.Paragraph className={_utils.cx(_styles, 'ht-min-sku-card-title')}>{skuName}</_Builtin.Paragraph>
      <_Builtin.Image
        className={_utils.cx(_styles, 'ht-min-sku-card-chevron')}
        loading="lazy"
        width="auto"
        height="auto"
        alt=""
        src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/611ff743f3b813db18cec442_Chevron.png"
      />
    </_Component>
  );
}
